import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";



const HikvisionStepUsage = ({ selectedOptions, setSelectedOptions, onNext, liveViewEnabled }) => {

    let USAGE_OPTIONS = [
        { key: "Control", title: "Control Hikvision", subtitle: "Control the status of channels or inputs" }
    ];

    if (liveViewEnabled){
        USAGE_OPTIONS.push({ key: "Live view", title: "Live camera viewing", subtitle: "Stream the camera feed" })
    }

    const toggle = (key) => {
        setSelectedOptions(prev => prev.includes(key) ? prev.filter(x => x !== key) : [...prev, key]);
    };

    return (
        <>
            <StepHeader title="How would you like to use the Hikvision?" subtitle="Choose one or both" />
            <StepBody>
                {USAGE_OPTIONS.map(opt => (
                    <OptionCard
                        key={opt.key}
                        title={opt.title}
                        subtitle={opt.subtitle}
                        selected={selectedOptions.includes(opt.key)}
                        onClick={() => toggle(opt.key)}
                    />
                ))}
            </StepBody>
            <StepNav onNext={onNext} nextDisabled={selectedOptions.length === 0} />
        </>
    );
};

export default HikvisionStepUsage;
